import { Pipe, PipeTransform } from '@angular/core';
import {Channel} from './iptv_editor.component';
/**
 * Фильтрует список каналов в зависимости от выбранной группы
 */
@Pipe({
  name: 'filterChannels',
  // Необходимо, чтобы список каналов постоянно изменялся при изменении элемента в массиве.
  pure: false,
})
export class FilterChannelsPipe implements PipeTransform {

  transform(channels: Channel[], channelsFiltered?:Channel[]): Channel[] {
      return channels.filter(
        channel => {
          return channelsFiltered.indexOf(channel) > -1 ? true : false;
        } 
     );
  }
}